module.exports = __webpack_public_path__ + "static/assets/4d0f6ea2ead9efa53b54f2c1279f7424.svg";